import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
} from "@mui/material";
import { useTemplateLOTOGridActionsAndButtons } from "../hooks/useTemplateLOTOsGridActionsAndButtons";

type Props = {
	showConfirmDialog: boolean;
	setShowConfirmDialog: (showConfirmDialog: boolean) => void;
	setIsCreatingLOTO: (isCreatingLOTO: boolean) => void;
	openPicker: (openPicker: boolean) => void;
	TemplateId: number | null;
};

export const AlertCreatingLOTODialog = ({
	showConfirmDialog,
	setShowConfirmDialog,
	setIsCreatingLOTO,
	openPicker,
	TemplateId,
}: Props) => {
	const { cancelAddLOTO, setAddButton, setSaveButton, setDiscardButton } =
		useTemplateLOTOGridActionsAndButtons({
			TemplateId,
			gridRef: null,
			searchTemplateLOTO: () => {},
			setRemoveLOTOError: () => {},
			setListMessage: () => {},
		});

	const handleDiscard = () => {
		cancelAddLOTO();
		setAddButton(true);
		setSaveButton(false);
		setDiscardButton(false);
		setShowConfirmDialog(false);
		setIsCreatingLOTO(false);
		openPicker(true);
	};

	return (
		<Dialog
			open={showConfirmDialog}
			onClose={() => setShowConfirmDialog(false)}
		>
			<DialogTitle style={{ paddingBottom: 0 }}>Warning</DialogTitle>
			<DialogContent>
				<DialogContentText>
					You are currently creating a new LOTO. Do you want to discard the
					changes and open the LOTO picker?
				</DialogContentText>
			</DialogContent>
			<Divider />
			<DialogActions style={{ padding: "16px " }}>
				<Button
					fullWidth
					onClick={handleDiscard}
					color="secondary"
					variant="contained"
				>
					Discard
				</Button>
				<Button
					fullWidth
					onClick={() => setShowConfirmDialog(false)}
					color="primary"
					variant="contained"
				>
					Continue creating
				</Button>
			</DialogActions>
		</Dialog>
	);
};
